import { Link, useNavigate } from "react-router-dom";
import { Plus, MapPin, Users, Wrench } from "lucide-react";
import { useFetch } from "@/lib/hooks";
import { addressText, fmtDate } from "@/lib/format";
import { StatusBadge, Coin, Empty, PageHead } from "@/components/common";

export function JobRow({ j, to }) {
  return (
    <Link to={to || `/jobs/${j.id}`} data-testid={`job-card-${j.id}`}
      className="block bg-white rounded-2xl border border-slate-200/80 p-4 hover:shadow-md transition-shadow fade-up">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-wider text-emerald-700">{j.category} · {j.mode === "direct" ? "Booking Langsung" : "Post Job"}</p>
          <h3 className="font-display font-bold text-slate-900 truncate">{j.title}</h3>
        </div>
        <StatusBadge status={j.status} />
      </div>
      <p className="text-xs text-slate-500 mt-2 flex items-start gap-1"><MapPin className="w-3.5 h-3.5 shrink-0 mt-0.5" /><span className="line-clamp-2">{addressText(j.address)}</span></p>
      <div className="flex items-center justify-between mt-3">
        <Coin value={j.price_coins} className="text-emerald-700 text-sm" />
        <span className="text-[11px] text-slate-400 flex items-center gap-2">
          {j.bring_tools && <span className="flex items-center gap-1 text-blue-700 font-bold"><Wrench className="w-3 h-3" />Bawa alat</span>}
          {j.status === "open" && <span className="flex items-center gap-1 text-amber-700 font-bold"><Users className="w-3 h-3" />{j.bid_count} tawaran</span>}
          {j.distance_km != null ? `${j.distance_km} km` : fmtDate(j.created_at)}
        </span>
      </div>
    </Link>
  );
}

export default function UserJobs() {
  const nav = useNavigate();
  const { data } = useFetch("/jobs/mine", { live: (e) => e.type === "job" || e.type === "notification" });
  return (
    <div data-testid="user-jobs-page">
      <PageHead title="Pekerjaan Saya" sub="Posting kebutuhan jasa & pantau prosesnya"
        right={<button data-testid="create-job-btn" onClick={() => nav("/jobs/new")}
          className="flex items-center gap-1 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold px-4 py-2 rounded-full transition-colors"><Plus className="w-4 h-4" /> Posting</button>} />
      <div data-testid="my-job-list" className="space-y-3">
        {!data ? <div className="h-24 bg-slate-200 rounded-2xl animate-pulse" /> :
          data.length === 0 ? <Empty title="Belum ada pekerjaan" desc="Posting pekerjaan pertama Anda untuk menerima penawaran worker." /> :
            data.map((j) => <JobRow key={j.id} j={j} />)}
      </div>
    </div>
  );
}
